import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LookupService } from '../../../shared/services/lookup.service';
import { LookUp } from '../../../shared/models/look-up.model';
import { SalvageRequestDTO } from '../../models/salvage-request-dto.model';
import { ResponseObject } from '../../../../shared/models/response-object.model';
import { NearestLocation, Languages, AllNearestLocation } from '../../../../shared/models/enums.model';
import { SalvageRequestorType } from '../../models/enums.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SalvageRequestService } from '../../services/salvage-request.service';
import { AlertService } from '../../../../shared/components/alert/alert.service';
import { GlobalServices } from '../../../../shared/services/global.service';
//import { AdminResponseDto } from '../../models/adminResponseDto';
//import { disableBindings } from '../../../../../../node_modules/@angular/core/src/render3';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { BaseRequestService } from '../../services/base-request.service';
import { CustomValidators } from '../../models/custom-validator';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-salvage-request',
  templateUrl: './salvage-request.component.html',
  styleUrls: ['./salvage-request.component.css']
})

export class SalvageRequestComponent implements OnInit {

  salvageRequestForm: FormGroup;
  salvageRequestDTO: SalvageRequestDTO;
  JobTypesOptions: LookUp[];
  ClassificationSocieties: LookUp[];
  AnchorageAreas: LookUp[];
  responseObj: ResponseObject;
  dropdownSettings = {};
  nearestLocation = AllNearestLocation;
  nearestLocationKey = Object.keys(this.nearestLocation);
  requestorType = SalvageRequestorType;
  requestorTypeKey = Object.keys(this.requestorType);
  submitted = false;
  loading = false;
  isReadOnly: boolean;
  RequestId: string;
  displayedLang: any;
  Languages = Languages;
  readonly OtherClassification: number = 17;
  showRequest = true;
  numberRegex: string = '^[0-9]*$';
  isErrorMessage: boolean = false;
  userInfo: any;
  baseRequestDTO: BaseRequest;
  invalidHours : boolean = false;


  constructor(private lookupService: LookupService, private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private salvageService: SalvageRequestService, private alertService: AlertService, private global: GlobalServices, private baseRequestService: BaseRequestService, private authSrevice: AuthenticationService) {

    if (history.state.data && history.state.data.requestId) {
      this.RequestId = history.state.data.requestId;
    }


    this.nearestLocationKey = this.nearestLocationKey.slice(this.nearestLocationKey.length / 2);
    this.requestorTypeKey = this.requestorTypeKey.slice(this.requestorTypeKey.length / 2);
    this.displayedLang = this.global.getLanguage();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.global.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.global.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.global.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
    this.createForm();
  }

  ngOnInit() {

    if (this.RequestId) {
      this.getBaseRequest();
    }
    if (history.state.data && history.state.data.isCompleted) {
      this.isReadOnly = true;
    }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    this.isReadOnly = this.RequestId ? true : false;

    // if (history.state.navigationId == 1 && this.isReadOnly == false && history.length > 2) {
    //   if(history.state.data == null&& this.isReadOnly == false){
    //   window.history.back();
    // }


    this.RequestId ? this.salvageRequestForm.disable() : null;
    this.getSalvageLookUps();
    if (this.isReadOnly) {
      this.salvageRequestForm.addControl('ClassificationSocietyOther', new FormControl('', [Validators.required, Validators.maxLength(50)]));
      this.editSalvageMode();
    }
  }

  // convenience getter for easy access to form fields
  get Validate() {
    return this.salvageRequestForm.controls;
  }

  getSalvageLookUps() {
    //Get JobTypes Lookup
    this.lookupService.GetJobTypes().subscribe(
      j => {
        this.JobTypesOptions = j.Data;
      }
    );

    //Get ClassificationSocieties Lookup
    this.lookupService.getClassificationSociety().subscribe(
      c => {
        this.ClassificationSocieties = c.Data;
      }
    );

    //Get AnchorageAreas Lookup
    this.lookupService.GetSalvageAnchorageAreas().subscribe(
      a => {
        this.AnchorageAreas = a.Data;
      }
    );
  }
  getBaseRequest() {

    this.baseRequestService.getBaseRequest(this.RequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;

      }
    )
  }
  editSalvageMode() {
    this.salvageService.getSalvageRequest(this.RequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.salvageRequestForm.patchValue({
            AgentName: resObj.Data['AgentName'],
            BriefDescription: resObj.Data['BriefDescription'],
            ClassificationSocietyId: resObj.Data['ClassificationSocietyId'],
            ClassificationSocietyOther: resObj.Data['ClassificationSocietyOther'],
            ETA: resObj.Data['ETA'],
            ETADate: new Date(resObj.Data['ETA']),
            ETATime: new Date(resObj.Data['ETA']),
            IMONo: resObj.Data['IMONo'],
            SelectedJobTypes: resObj.Data['JobTypes'],
            NearestLocation: resObj.Data['NearestLocation'],
            SalvageAnchorageAreaId: resObj.Data['SalvageAnchorageAreaId'],
            SalvageRequestorType: resObj.Data['SalvageRequestorType'],
            ShipParticular: resObj.Data['ShipParticular'],
            MobileNumber: resObj.Data['MobileNumber'],
            Fax: resObj.Data['Fax'],
            TermsAndConditionsControl: true
          });
          this.userInfo = {
            MobileNumber: resObj.Data['MobileNumber'],
            Fax: resObj.Data['Fax']
          };
          // console.log("Success");
        }
        else {
          // console.log("Fail");
        }
      });
  }

  createForm() {
    this.salvageRequestForm = this.formBuilder.group({
      CurrUserId: [this.authSrevice.currentUserValue.UserId],
      SelectedJobTypes: ['', Validators.required],
      JobTypesIds: [''],
      BriefDescription: ['', [Validators.required, Validators.maxLength(500)]],
      ETA: [''],
      ETADate: [new Date(),[ Validators.required,CustomValidators.dateValidator()]],
      ETATime: [new Date(), Validators.required],
      IMONo: ['', [Validators.required, Validators.pattern("^[0-9]{7,7}$")]],
      ShipParticular: ['', [Validators.maxLength(500)]],
      SalvageRequestorType: ['', Validators.required],
      AgentName: ['', [Validators.required, Validators.maxLength(50)]],
      ClassificationSocietyId: ['undefined', Validators.required],
      SalvageAnchorageAreaId: ['undefined', Validators.required],
      NearestLocation: ['', Validators.required],
      TermsAndConditionsControl: ['', Validators.requiredTrue],
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.salvageRequestForm.invalid || this.Validate.ClassificationSocietyId.value == "undefined" || this.Validate.SalvageAnchorageAreaId.value == "undefined") {
      return;
    }

    //this.salvageRequestForm.controls['MobileNumber'].setValue(this.salvageRequestForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.global.isLoaderEnabled = true;
    let SelectedJobTyesIds = this.salvageRequestForm.controls['SelectedJobTypes'].value.map(function (currItem) {
      return currItem.Id;
    });
    this.salvageRequestForm.controls['JobTypesIds'].setValue(SelectedJobTyesIds);


 var selectedDate = this.salvageRequestForm.get("ETADate").value.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
      var selectedTime = this.salvageRequestForm.get("ETATime").value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
      var fullDate = selectedDate + ", " + selectedTime;
      this.salvageRequestForm.controls['ETA'].setValue(fullDate);


   //var selectedDate = this.salvageRequestForm.get("ETADate").value.toLocaleDateString();

    // var selectedTime = this.salvageRequestForm.get("ETATime").value.toLocaleTimeString();
    // var fullDate = selectedDate + " " + selectedTime;
    // var fullVisitDate = new Date(fullDate.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")).toLocaleString();
    // this.salvageRequestForm.controls['ETA'].setValue(fullVisitDate);
    this.loading = true;
    this.salvageRequestDTO = this.salvageRequestForm.value;
    this.salvageRequestDTO.MobileNumber = this.salvageRequestForm.controls.MobileNumber.value;
    this.salvageService.addSalvageRequest(this.salvageRequestDTO).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.salvageRequestForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Fail");
        }


      });
  }

  onClassificationChange(optionValue) {
    if (optionValue == this.OtherClassification) {
      this.salvageRequestForm.addControl('ClassificationSocietyOther', new FormControl('', [Validators.required, Validators.maxLength(50)]));
    }
    else {
      if (this.salvageRequestForm.controls['ClassificationSocietyOther'] != null) {
        this.salvageRequestForm.removeControl('ClassificationSocietyOther');
      }
    }
  }

  goToTermsAndConditions(): void {
    if (this.global.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }
}
